// extracted by mini-css-extract-plugin
module.exports = {"root":"ColoredButton_root__vB7_k","yellowColor":"ColoredButton_yellowColor__eg8ZZ","purpleColor":"ColoredButton_purpleColor__pwQDX","image":"ColoredButton_image__RDftZ"};